import React from 'react';
import PropTypes from 'prop-types';
import TrackWaveform from '../../atoms/TrackWaveform';
import './index.scss';

export default function TrackRow({
  index,
  title,
  meta,
  cover,
  plays,
  progress = 0,
  seed,
  isPlaying = false,
  onPlay,
  onSeek,
  actions,
  className = '',
}) {
  const classes = ['track-row', actions && 'track-row--has-actions', className].filter(Boolean).join(' ');
  const numLabel = typeof index === 'number'
    ? String(index).padStart(2, '0')
    : (index || '00');

  return (
    <article className={classes}>
      <div className="track-row__num">{numLabel}</div>
      <div
        className={`track-row__cover${cover ? '' : ' track-row__cover--placeholder'}`}
        style={cover ? { backgroundImage: `url(${cover})` } : undefined}
      >
        {!cover ? (
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M9 18V5l11-2v13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="6" cy="18" r="3" stroke="currentColor" strokeWidth="1.8" />
            <circle cx="17" cy="16" r="3" stroke="currentColor" strokeWidth="1.8" />
          </svg>
        ) : null}
      </div>
      <div className="track-row__body">
        <h3 className="track-row__title">{title}</h3>
        {meta ? <div className="track-row__meta">{meta}</div> : null}
      </div>
      <TrackWaveform
        bars={56}
        seed={typeof seed === 'number' ? seed : (Number.isFinite(Number(index)) ? Number(index) : 1)}
        progress={progress}
        onSeek={onSeek}
        ariaLabel={`${isPlaying ? 'Playing' : 'Seek'} ${typeof title === 'string' ? title : 'track'}`}
        className="track-row__wave"
      />
      {plays != null ? <div className="track-row__plays">{plays}</div> : <div className="track-row__plays-spacer" aria-hidden="true" />}
      <button
        type="button"
        className={`track-row__play${isPlaying ? ' track-row__play--active' : ''}`}
        aria-label={isPlaying ? 'Pause' : 'Play'}
        aria-pressed={isPlaying}
        onClick={onPlay}
      >
        {isPlaying ? (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M7 5h4v14H7zM13 5h4v14h-4z" />
          </svg>
        ) : (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M8 5v14l11-7z" />
        </svg>
        )}
      </button>
      {actions ? <div className="track-row__actions">{actions}</div> : null}
    </article>
  );
}

TrackRow.propTypes = {
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.node.isRequired,
  meta: PropTypes.node,
  cover: PropTypes.string,
  plays: PropTypes.node,
  progress: PropTypes.number,
  seed: PropTypes.number,
  isPlaying: PropTypes.bool,
  onPlay: PropTypes.func,
  onSeek: PropTypes.func,
  actions: PropTypes.node,
  className: PropTypes.string,
};
